import { Department } from './department';

export enum ProjectLineType {
  Task = 'nextgenTask',
  Material = 'nextgenMaterial',
  Meeting = 'nextgenMeeting',
}

export enum ProjectLineStatus {
  Todo = 'to_do',
  InProgress = 'in_progress',
  OnHold = 'on_hold',
  Done = 'done',
  NoLinkedMeeting = 'no_linked_meeting',
}

export interface ProjectLine {
  id: string;
  type: ProjectLineType;
  title: string;
  status: ProjectLineStatus;
}

export interface ProjectGroup {
  id: string;
  title: string;
  color: string;
  lines: ProjectLine[];
}

export interface Project {
  id: string;
  department: Department;
  title: string;
  lines: Array<ProjectLine | ProjectGroup>;
  startDate: string | null;
  endDate: string | null;
}

export const isProjectLine = (line: ProjectLine | ProjectGroup): line is ProjectLine => {
  return 'type' in line;
};
